<template>
  <footer class="bg-(--brand-primary) text-white pt-16 pb-8 px-8">
    <div class="max-w-(--max-width) mx-auto">
      <slot/>

      <hr class="my-8"/>

      <div
        class="flex flex-col justify-start items-start lg:flex-row lg:justify-between  lg:items-center">
        <div class="mb-10 lg:mb-0">
          <p class="text-base text-white font-medium">© {{ new Date().getFullYear() }}
            Claims for Cars. All rights
            reserved.</p>
          <p class="text-xs text-white">Claims for Cars is a trading style of JLG Legal Ltd, which
            also trades as the Johnson Law Group and is regulated by the Solicitors Regulation
            Authority.</p>
        </div>

        <div class="flex justify-end space-x-4">
          <a href="https://www.facebook.com/ClaimsForCars/"
             class="text-white hover:opacity-60 flex items-center justify-center">
            <span class="sr-only">Facebook</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor"
                 stroke="currentColor" stroke-width="0" viewBox="0 0 448 512">
              <path stroke="none"
                    d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/claimsforcars/"
             class="text-white hover:opacity-60 flex items-center justify-center">
            <span class="sr-only">Instagram</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor"
                 stroke="currentColor" stroke-width="0" viewBox="0 0 448 512">
              <path stroke="none"
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
            </svg>
          </a>
          <a href="https://x.com/claimsforcars"
             class="text-white hover:opacity-60 flex items-center justify-center">
            <span class="sr-only">X</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="h-6 w-6"
                 viewBox="0 0 25 24">
              <path
                d="M16.933 4.58h2.382l-5.202 6.241 6.12 8.494h-4.79l-3.755-5.15-4.292 5.15H5.011l5.563-6.677L4.708 4.58H9.62l3.39 4.708 3.923-4.708Zm-.836 13.24h1.319L8.9 5.998H7.484l8.613 11.824Z"/>
            </svg>
          </a>
          <a class="hover:opacity-50" href="javascript: Cookiebot.renew()">Cookie consent</a>
        </div>
      </div>
    </div>
  </footer>
</template>

